import { render } from "./SkillList.vue?vue&type=template&id=4ef4f181&scoped=true"
import script from "./SkillList.vue?vue&type=script&lang=js"
export * from "./SkillList.vue?vue&type=script&lang=js"

import "./SkillList.vue?vue&type=style&index=0&id=4ef4f181&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef4f181"]])

export default __exports__